/**
 * What a non-admin sees on tile.game while `siteAccess.tile` is `admins` (11 §8.6): the name and a way to tarock.game.
 * Imported eagerly (it renders outside the router, where a lazy route cannot suspend).
 */
import { t } from '@tarock/i18n';
import { SITES } from '@tarock/protocol/sites';
import { siteHome } from '../../app/site';

/** The plain page of a closed tile.game. */
export function TileClosed() {
  return (
    <main class="page" id="main" data-page="site-closed">
      <section class="hero">
        <h1>{SITES.tile.name}</h1>
        <p>
          <a class="btn" href={siteHome('tarock')}>
            {t('site.tile.toTarock')}
          </a>
        </p>
      </section>
    </main>
  );
}
